import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { removeCookie } from 'helpers/cookie'
import { currentUserSelector } from 'store/users'
import { AvatarSpecial } from 'ui/components/AvatarSpecial'
import Icon from '../Icon'
import Scrollbar from '../Scrollbar'
import { Menu, Logo } from './components'
import {
  SidebarRoot,
  SidebarHeader,
  SidebarLogo,
  User,
  UserHeader,
  UserInfo,
  UserAvatar,
  UserName,
  UserPosition,
  UserControls,
  UserLink,
  SidebarMenu,
  SidebarToggle,
} from './styled'

const Sidebar = ({ opened, setMenuOpened }) => {
  const router = useRouter()
  const currentUser = useSelector(currentUserSelector)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]

    body.style.setProperty('--padding-left-content', hidden ? '56px' : '272px')
  }, [hidden])

  const logoutHandler = () => {
    removeCookie('ac_token')
    router.push('/auth')
  }

  return (
    <SidebarRoot hide={hidden} opened={opened}>
      <SidebarHeader>
        <SidebarLogo>
          <Link href="/">
            <a>
              <Logo />
            </a>
          </Link>
        </SidebarLogo>
        <SidebarToggle
          hide={hidden}
          onClick={() => setHidden(!hidden)}
          title={hidden ? 'Развернуть' : 'Свернуть'}
        >
          <Icon name={hidden ? 'sidebar-open' : 'sidebar-close'} />
        </SidebarToggle>
      </SidebarHeader>
      <User>
        <UserHeader>
          <UserAvatar>
            <AvatarSpecial
              src={currentUser?.avatar?.link}
              isApi={currentUser?.avatar?.is_api}
            />
          </UserAvatar>
          <UserInfo>
            <UserName>
              {currentUser?.name} {currentUser?.surname}
            </UserName>
            <UserPosition>{currentUser?.position}</UserPosition>
          </UserInfo>
        </UserHeader>
        <UserControls>
          {currentUser?.id ? (
            <Link href="/users/[userId]" as={`/users/${currentUser.id}`}>
              <UserLink as="a" onClick={() => setMenuOpened(false)}>
                <Icon name="user" size="12" />
                Профиль
              </UserLink>
            </Link>
          ) : (
            <UserLink as="span">
              <Icon name="user" size="12" />
              Профиль
            </UserLink>
          )}
          <UserLink onClick={logoutHandler}>Выйти</UserLink>
        </UserControls>
      </User>
      <SidebarMenu>
        <Scrollbar>
          <Menu setMenuOpened={setMenuOpened} hide={hidden} />
        </Scrollbar>
      </SidebarMenu>
    </SidebarRoot>
  )
}

export default Sidebar
